// extracted by mini-css-extract-plugin
export var container = "VideosContainer-module--container--1lpp3";
export var modal = "VideosContainer-module--modal--3kbsT";
export var modalContainer = "VideosContainer-module--modalContainer--2O3Wp";